import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiFetch } from "../utils/wkCommon";
import SongCard from "../components/SongCard";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SongSharing() {
  const { code } = useParams();
  const cleanCode = code?.trim();

  const [loading, setLoading] = useState(true);
  const [expired, setExpired] = useState(false);
  const [song, setSong] = useState(null);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    load();
  }, [code]);

  async function load() {
    setLoading(true);

    try {
      // ===== GET SHARING =====
      const url = `${API_URL}/api/song-sharings?filters%5BshareCode%5D%5B$eq%5D=${cleanCode}&populate[0]=virtuous_song&populate[1]=song_file&populate[song_file][populate][0]=mediaFile&populate[song_file][populate][1]=virtuous_song`;

      const res = await apiFetch(url);

      const sharing = res?.data?.[0];
      if (!sharing) throw new Error("Not found");

      // ===== EXPIRED CHECK =====
      if (new Date(sharing.expiredAt) < new Date()) {
        setExpired(true);
        return;
      }

      // ===== TYPE =====
      if (sharing.shareType === "song") {
        const songId = sharing.virtuous_song?.documentId;

        const filesUrl = `${API_URL}/api/song-files?filters%5Bvirtuous_song%5D%5BdocumentId%5D%5B$eq%5D=${songId}&populate[0]=mediaFile`;

        const filesRes = await apiFetch(filesUrl);

        setSong(sharing.virtuous_song);
        setFiles(filesRes?.data || []);
      } else {
        const file = sharing.song_file;

        setFiles([file]);

        // 👉 ambil song dari file
        if (file?.virtuous_song) {
          setSong(file.virtuous_song);
        }
      }

    } catch (e) {
      console.error(e);
      setExpired(true);
    } finally {
      setLoading(false);
    }
  }

  // ===== HELPERS =====
  function downloadFile(url, filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "file";
    a.target = "_blank";
    a.click();
  }

  function openUrl(url) {
    window.open(url, "_blank");
  }

  function isYoutube(url) {
    return url?.includes("youtube.com") || url?.includes("youtu.be");
  }

  function extractYoutubeId(url) {
    try {
      const u = new URL(url);
      if (u.hostname.includes("youtu.be")) return u.pathname.slice(1);
      return u.searchParams.get("v");
    } catch {
      return "";
    }
  }

  function formatSize(bytes) {
    if (!bytes) return "-";
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  }

  // ===== RENDER FILE =====
  function renderFile(r) {
    const file = r.mediaFile?.[0];

    return (
      <div key={r.id}
        className="content-row"
        style={{
          cursor: "default",
          display: "flex",
          justifyContent: "space-between",
          background: "#fff",
          borderRadius: "0.75rem",
          padding: "0.75rem",
          marginBottom: "0.5rem",
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)"
        }}
      >
        
        <div style={{ fontSize: "1rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <b>
              {r.filetype} | {file ? "File" : "URL"}
              {r.filesize && (
                <span style={{ color: "#999", fontSize:"0.8rem", paddingLeft:"0.5rem" }}>
                  {formatSize(r.filesize)}
                </span>
              )}
            </b>
          </div>

          <div>
            {file?.name || r.mediaUrl || "-"}
          </div>

          <div style={{ display: "flex", marginTop: "0.125rem" }}>
            {r.romanization && (
              <>
                <span style={{ color: "green", fontSize: "0.8rem", paddingRight: "0.5rem" }}>✔ </span>
                <span style={{ color: "#666", fontSize: "0.8rem", paddingRight: "1.5rem" }}>
                  拼音 Pinyin
                </span>
              </>
            )}

            {r.translation && (
              <>
                <span style={{ color: "green", fontSize: "0.8rem", paddingRight: "0.5rem" }}>✔ </span>
                <span style={{ color: "#666", fontSize: "0.8rem" }}>
                  翻譯 Terjemahan
                </span>
              </>
            )}
          </div>
        </div>

        <div style={{ display: "flex", gap: 4, alignItems: "center" }}>

          {/* DOWNLOAD FILE */}
          {file?.url && (
            <button
              style={{
                cursor: "pointer",
                width: "40px",
                fontSize: "1.2rem",
                border: "1px solid #ddd",
                borderRadius: "0.5rem",
                background: "#fff"
              }}
              onClick={() => downloadFile(file.url, file.name)}
            >
              ⬇️
            </button>
          )}

          {/* OPEN URL */}
          {r.mediaUrl && (
            <button
              style={{
                cursor: "pointer",
                width: "40px",
                fontSize: "1.2rem",
                border: "1px solid #ddd",
                borderRadius: "0.5rem",
                background: "#fff"
              }}
              onClick={() => openUrl(r.mediaUrl)}
            >
              🔗
            </button>
          )}

          {/* YOUTUBE */}
          {isYoutube(r.mediaUrl) && (
            <button
              style={{
                cursor: "pointer",
                width: "40px",
                fontSize: "1.2rem",
                border: "1px solid #ddd",
                borderRadius: "0.5rem",
                background: "#fff"
              }}
              onClick={() =>
                openUrl(`https://ssyoutube.com/watch?v=${extractYoutubeId(r.mediaUrl)}`)
              }
            >
              ▶️⬇️
            </button>
          )}
        </div>
      </div>
    );
  }


  return (
    <div style={{
      fontWeight: 500,
      fontSize: "1rem",
      marginBottom: "1rem",
      padding: "0.5rem 0.75rem",
      background: "#fff",
      borderRadius: "0.75rem",
      boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
      }}>

      {/* TITLE */}
      <div style={{
        fontWeight: 700,
        fontSize: "1.25rem",
        marginBottom: "1rem"
      }}>
        善歌 Lagu Suci
      </div>

      {/* LOADING */}
      {loading && <div>Loading...</div>}

      {/* EXPIRED */}
      {!loading && expired && (
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          ❌ Link expired / tidak valid
        </div>
      )}

      {/* CONTENT */}
      {!loading && !expired && (
        <>
          {song && (
            <div style={{
              background: "#fff",
              fontSize: "1.5rem",
              borderRadius: "0.75rem",
              padding: "0.75rem",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              marginBottom: "0.75rem"
            }}>
              <SongCard
                song={song}
                onPlay={() => {}}
                isPlaying={false}
                hideMeta
              />
            </div>
          )}

          <div style={{
            fontSize: "1rem",
            fontWeight: 600,
            color: "#666",
            margin: "0.5rem 0"
          }}>
            Files
          </div>
          {files.map(renderFile)}
        </>
      )}
    </div>
  );
  }